module.exports = __webpack_public_path__ + "static/media/apartment21.280f508e.jpg";